import { useContext, useMemo } from "react";
import { useSWRConfig } from "swr";
import { useSSRSafeEffect } from "./useSSRSafeEffect";
import { ReactRequestContext } from "../context/RequestContext/index";

export const useRequestContext = () => {
  const requestContext = useContext(ReactRequestContext);
  const swr = useSWRConfig();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const val = useMemo(() => ({ ...requestContext, swr }), [requestContext]);
  useSSRSafeEffect(() => void (val.swr = swr));

  return val;
};
